import { handleActions } from 'redux-actions';
import Immutable from 'seamless-immutable';
import utils from '../../utils';
import actions from '../actions';

const initialState = Immutable({
  nodes: {},
  initialized: false,
  pointer: {
    enabled: false,
    config: {
      uuidOnly: true,
      mode: 'select',
      enabledEvents: {},
    },
    hit: null,
    operation: {
      points: [],
      parentId: null,
      type: null,
    },
  },
  selectedNodes: [],
});

export default handleActions(
  {
    [actions.segmentation.ready]: (state) => state.set('initialized', true),
    [actions.segmentation.loadNodes]: (state, { payload: { nodes } }) =>
      state.merge({ nodes }),
    [actions.segmentation.nodeAdded]: (state, { payload: { node } }) => {
      const nodes = utils.traverseReduce(
        node,
        (acc, child) => {
          acc[child.uuid] = utils.getStateForNode(child);
          return acc;
        },
        {},
        true,
      );
      return state
        .merge({ nodes }, { deep: true })
        .setIn(
          ['nodes', node.parent.uuid, 'childrenByType', node.type, node.uuid],
          true,
        );
    },
    [actions.segmentation.nodeRemoved]: (
      state,
      { payload: { node, parentNode } },
    ) =>
      state
        .set('nodes', state.nodes.without(node.uuid))
        .setIn(['nodes', parentNode.uuid], utils.getStateForNode(parentNode)),
    [actions.segmentation.nodeChanged]: (
      state,
      { payload: { uuid, properties } },
    ) => state.merge({ nodes: { [uuid]: { properties } } }, { deep: true }),
    [actions.segmentation.setPointerHit]: (state, { payload: { hit } }) =>
      state.setIn(['pointer', 'hit'], hit),
    [actions.segmentation.updatePointerConfig]: (
      state,
      { payload: { updater } },
    ) => state.merge({ pointer: { config: updater } }, { deep: true }),
    [actions.segmentation.enablePointer]: (state) =>
      state.setIn(['pointer', 'enabled'], true),
    [actions.segmentation.disablePointer]: (state) =>
      state.setIn(['pointer', 'enabled'], false),
    [actions.segmentation.addNodeSelection]: (state, { payload: { uuids } }) =>
      state.set('selectedNodes', state.selectedNodes.concat(uuids)),
    [actions.segmentation.removeNodeSelection]: (
      state,
      { payload: { uuids } },
    ) =>
      state.set(
        'selectedNodes',
        state.selectedNodes.filter((id) => !uuids.includes(id)),
      ),
    [actions.segmentation.setNodeSelection]: (state, { payload: { uuids } }) =>
      state.set('selectedNodes', uuids),
    [actions.segmentation.clearNodeSelection]: (state) =>
      state.set('selectedNodes', []),
    [actions.segmentation.beginOperation]: (
      state,
      { payload: { parentId, firstPoint } },
    ) =>
      state.merge(
        { pointer: { operation: { parentId, points: [firstPoint] } } },
        { deep: true },
      ),
    [actions.segmentation.addOperationPoint]: (state, { payload: { point } }) =>
      state.setIn(
        ['pointer', 'operation', 'points'],
        state.pointer.operation.points.concat([point]),
      ),
    [actions.segmentation.clearOperation]: (state) =>
      state.merge(
        { pointer: { operation: { parentId: null, points: [] } } },
        { deep: true },
      ),
  },
  initialState,
);
